/* ==========================================================================
   BioHippo — Resources & Insights — mobile filter drawer
   Progressive add-on to resources-insights.js. It does not touch the
   filtering logic; it only re-homes the existing sidebar into a bottom
   sheet on screens <= 900px, adds a "Filters" button to the toolbar,
   turns facet groups into accordions, caps long lists, and mirrors the
   live result count onto the drawer's "Show results" button.
   ========================================================================== */
(function () {
  'use strict';

  var MQ = window.matchMedia('(max-width: 900px)');
  var CAP = 8; // rows shown per facet before "Show all"

  var ICON_FILTER = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M4 6h16M7 12h10M10 18h4"/></svg>';
  var ICON_X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>';

  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  /* classList.add/remove re-set the attribute even when nothing changes, which
     would re-trigger our MutationObserver forever — so only touch it on change */
  function setClass(el, name, on) {
    if (el.classList.contains(name) !== on) el.classList.toggle(name, on);
  }

  /* height of the theme's sticky header, so "scroll to results" lands below it */
  function headerOffset() {
    var h = document.querySelector('.shopify-section-header-sticky, .section-header, .shopify-section-group-header-group');
    var r = h ? h.getBoundingClientRect() : null;
    return (r && r.top <= 1 && r.height < 260 ? r.height : 0) + 12;
  }

  each(document.querySelectorAll('[data-ri]'), function (root) {
    var sidebar   = root.querySelector('[data-ri-sidebar]');
    var head      = sidebar && sidebar.querySelector('.ri__sidebar-head');
    var facetsBox = root.querySelector('[data-ri-facets]');
    var tools     = root.querySelector('.ri__tools');
    var applied   = root.querySelector('[data-ri-applied]');
    var countEl   = root.querySelector('[data-ri-count]');
    var searchIn  = root.querySelector('[data-ri-search]');
    if (!sidebar || !head || !facetsBox || !tools) return;

    var drawerId = 'ri-drawer-' + Math.random().toString(36).slice(2, 8);
    sidebar.id = sidebar.id || drawerId;

    /* ---- toolbar "Filters" button ---- */
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ri__filters-btn';
    btn.setAttribute('aria-controls', sidebar.id);
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML = ICON_FILTER + '<span>Filters</span><span class="ri__filters-n" hidden></span>';
    tools.insertBefore(btn, tools.firstChild);
    var badge = btn.querySelector('.ri__filters-n');

    /* wrap the "Cards" / "List" text so it can be hidden on narrow screens */
    each(root.querySelectorAll('[data-ri-view]'), function (b) {
      each(Array.prototype.slice.call(b.childNodes), function (n) {
        if (n.nodeType === 3 && n.textContent.trim()) {
          var s = document.createElement('span');
          s.className = 'ri__view-label';
          s.textContent = n.textContent.trim();
          b.replaceChild(s, n);
        }
      });
    });

    /* ---- drawer chrome: close button, footer, backdrop ---- */
    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'ri__sidebar-close';
    closeBtn.setAttribute('aria-label', 'Close filters');
    closeBtn.innerHTML = ICON_X;
    head.appendChild(closeBtn);

    var foot = document.createElement('div');
    foot.className = 'ri__sidebar-foot';
    var showBtn = document.createElement('button');
    showBtn.type = 'button';
    showBtn.className = 'ri__sidebar-show';
    showBtn.textContent = 'Show results';
    foot.appendChild(showBtn);
    sidebar.appendChild(foot);

    var backdrop = document.createElement('div');
    backdrop.className = 'ri__backdrop';
    sidebar.parentNode.insertBefore(backdrop, sidebar);

    /* ---- open / close ---- */
    var lastFocus = null;
    function openDrawer() {
      if (!MQ.matches) return;
      lastFocus = document.activeElement;
      sidebar.classList.add('is-open');
      backdrop.classList.add('is-open');
      sidebar.setAttribute('role', 'dialog');
      sidebar.setAttribute('aria-modal', 'true');
      sidebar.setAttribute('aria-label', 'Filters');
      document.documentElement.classList.add('ri-lock');
      btn.setAttribute('aria-expanded', 'true');
      closeBtn.focus();
    }
    function closeDrawer() {
      sidebar.classList.remove('is-open');
      backdrop.classList.remove('is-open');
      sidebar.removeAttribute('role');
      sidebar.removeAttribute('aria-modal');
      document.documentElement.classList.remove('ri-lock');
      btn.setAttribute('aria-expanded', 'false');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    btn.addEventListener('click', function () {
      sidebar.classList.contains('is-open') ? closeDrawer() : openDrawer();
    });
    closeBtn.addEventListener('click', closeDrawer);
    backdrop.addEventListener('click', closeDrawer);
    showBtn.addEventListener('click', function () {
      closeDrawer();
      // land the user on the result list, not back at the hero
      var target = root.querySelector('.ri__toolbar') || root;
      var y = target.getBoundingClientRect().top + window.pageYOffset - headerOffset();
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sidebar.classList.contains('is-open')) closeDrawer();
    });
    var onMQ = function () { if (!MQ.matches) closeDrawer(); };
    if (MQ.addEventListener) MQ.addEventListener('change', onMQ); else MQ.addListener(onMQ);

    /* ---- accordion state per facet (survives re-render) ---- */
    var open = { 'content type': true }; // everything else starts collapsed on mobile

    function labelKey(facet) {
      var lab = facet.querySelector('.ri-facet__label');
      if (!lab) return '';
      var s = lab.getAttribute('data-ri-key');
      if (s) return s;
      s = (lab.firstChild && lab.firstChild.nodeType === 3 ? lab.firstChild.textContent : lab.textContent).trim().toLowerCase();
      lab.setAttribute('data-ri-key', s);
      return s;
    }

    facetsBox.addEventListener('click', function (e) {
      var lab = e.target.closest ? e.target.closest('.ri-facet__label') : null;
      if (!lab || !MQ.matches) return;
      var facet = lab.parentNode;
      var key = labelKey(facet);
      open[key] = !open[key];
      facet.classList.toggle('is-collapsed', !open[key]);
    });

    function decorate() {
      each(facetsBox.querySelectorAll('.ri-facet'), function (facet) {
        var key = labelKey(facet);
        var lab = facet.querySelector('.ri-facet__label');
        setClass(facet, 'is-collapsed', !open[key]);

        // selected-count badge on the group label
        var sel = facet.querySelectorAll('.ri-facet__row input:checked').length;
        if (!sel) {
          var act = facet.querySelector('.ri-type button.is-active');
          if (act && act.textContent.trim().indexOf('All') !== 0) sel = 1;
        }
        var b = lab.querySelector('.ri-facet__sel');
        if (!b) { b = document.createElement('span'); b.className = 'ri-facet__sel'; lab.appendChild(b); }
        if (b.textContent !== String(sel)) b.textContent = sel;   // only mutate on change (observer feedback guard)
        if (b.hidden !== (sel === 0)) b.hidden = sel === 0;

        // cap long lists
        var list = facet.querySelector('.ri-facet__list');
        if (!list) return;
        var rows = list.querySelectorAll('.ri-facet__row').length;
        var more = facet.querySelector('.ri-facet__more');
        if (rows > CAP) {
          setClass(list, 'is-capped', true);
          if (!more) {
            more = document.createElement('button');
            more.type = 'button';
            more.className = 'ri-facet__more';
            more.addEventListener('click', function () {
              var l = facet.querySelector('.ri-facet__list');
              var expanded = l.classList.toggle('is-expanded');
              more.textContent = expanded ? 'Show fewer' : 'Show all ' + l.querySelectorAll('.ri-facet__row').length;
            });
            facet.appendChild(more);
          }
          var label = list.classList.contains('is-expanded') ? 'Show fewer' : 'Show all ' + rows;
          if (more.textContent !== label) more.textContent = label;
          if (more.hidden) more.hidden = false;
        } else {
          setClass(list, 'is-capped', false);
          if (more && !more.hidden) more.hidden = true;
        }
      });
    }

    /* ---- mirror counts: button badge + "Show N results" ---- */
    function syncCounts() {
      var pills = applied ? applied.querySelectorAll('.ri-pill') : [];
      var n = 0;
      each(pills, function (p) { if (p.textContent.trim().charAt(0) !== '“') n++; }); // ignore the search-term pill
      if (badge.textContent !== String(n)) badge.textContent = n;
      if (badge.hidden !== (n === 0)) badge.hidden = n === 0;
      var txt = countEl ? countEl.textContent.replace(/^[\s·]+/, '').trim() : '';
      var lbl = txt ? 'Show ' + txt : 'Show results';
      if (showBtn.textContent !== lbl) showBtn.textContent = lbl;
    }

    var scheduled = false;
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      setTimeout(function () { scheduled = false; decorate(); syncCounts(); }, 0); // setTimeout, not rAF: rAF stalls in background tabs
    }
    new MutationObserver(schedule).observe(facetsBox, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    if (applied) new MutationObserver(schedule).observe(applied, { childList: true, subtree: true, attributes: true });
    if (countEl) new MutationObserver(schedule).observe(countEl, { childList: true, characterData: true, subtree: true });
    facetsBox.addEventListener('change', schedule);
    schedule();

    /* ---- on mobile, finishing a search (Go/Enter) or tapping a Popular chip lands on the results ---- */
    function gotoResults() {
      if (!MQ.matches) return;
      var target = root.querySelector('.ri__toolbar');
      if (!target) return;
      var rect = target.getBoundingClientRect();
      if (rect.top > window.innerHeight * 0.6) {
        window.scrollTo({ top: rect.top + window.pageYOffset - headerOffset(), behavior: 'smooth' });
      }
    }
    if (searchIn) {
      searchIn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && searchIn.value.trim()) { searchIn.blur(); setTimeout(gotoResults, 50); }
      });
    }
    each(root.querySelectorAll('[data-ri-quick]'), function (chip) {
      chip.addEventListener('click', function () { setTimeout(gotoResults, 50); });
    });
  });
})();
